import React from 'react';
import PublicationCard from './PublicationCard';
import { FileText, Loader } from 'lucide-react';

const PublicationList = ({ publications, loading, onView, onDelete, onToggleVisibility }) => {
  if (loading) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="text-center">
          <Loader size={48} className="text-[#FF6B00] animate-spin mx-auto mb-4" />
          <p className="text-gray-600">Chargement des publications...</p>
        </div>
      </div>
    );
  }

  if (!publications || publications.length === 0) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="text-center">
          <FileText size={64} className="text-gray-300 mx-auto mb-4" />
          <h3 className="text-xl font-semibold text-gray-700 mb-2">
            Aucune publication trouvée
          </h3>
          <p className="text-gray-500">
            Aucune publication ne correspond aux critères de recherche
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {publications.map((publication) => (
        <PublicationCard
          key={publication.id}
          publication={publication}
          onView={onView}
          onDelete={onDelete}
          onToggleVisibility={onToggleVisibility}
        />
      ))}
    </div>
  );
};

export default PublicationList;
